import wiredWirelessNetwork from "public/network-services/icons/wired-wireless-network.png";
import { SimpleList } from "@/components/list";

const LAN_WAN_POINTS = [
  "Scalable & secure wired connectivity for high-speed data transfer and secure communication.",
  "Advanced network segmentation with VLANs and subnetting for better security.",
  "Redundant pathways to ensure network resilience and prevent single points of failure.",
];

const WIFI_POINTS = [
  "Wi-Fi 6 technology for increased speed, capacity, and efficiency.",
  "Guest access management with secure, user-friendly visitor connectivity.",
  "IoT-ready infrastructure to support numerous connected devices efficiently.",
];

const ROAMING_POINTS = [
  "Smart handover mechanisms for uninterrupted device connectivity.",
  "Zero packet loss solutions to maintain data integrity during transitions.",
  "Optimized for mobile workforces needing consistent connectivity.",
];

const SECURITY_POINTS = [
  "WPA3 encryption & firewall protection to prevent unauthorized access.",
  "Proactive monitoring & bandwidth management for optimal network performance.",
  "Regulatory compliance to meet industry standards and protect data.",
];

export const SOLUTIONS_CONSTANTS = {
  title: "Features of Wired and Wireless Networking Solutions",
  list: [
    {
      content: <SimpleList points={LAN_WAN_POINTS} />,
      image: wiredWirelessNetwork,
      title: "Enterprise-Grade LAN & WAN",
    },
    {
      content: <SimpleList points={WIFI_POINTS} />,
      image: wiredWirelessNetwork,
      title: "High-Performance Wi-Fi Solutions",
    },
    {
      content: <SimpleList points={ROAMING_POINTS} />,
      image: wiredWirelessNetwork,
      title: "Seamless Roaming & Mobility",
    },
    {
      content: <SimpleList points={SECURITY_POINTS} />,
      image: wiredWirelessNetwork,
      title: "Network Security & Optimization",
    },
  ],
};
